import { render, staticRenderFns } from "./DetailMinTableNew.vue?vue&type=template&id=c202f89a&scoped=true&"
import script from "./DetailMinTableNew.vue?vue&type=script&lang=js&"
export * from "./DetailMinTableNew.vue?vue&type=script&lang=js&"
import style0 from "./DetailMinTableNew.vue?vue&type=style&index=0&id=c202f89a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c202f89a",
  null
  
)

export default component.exports